import {Component, Input} from '@angular/core';
import {KENDO_PROGRESSBAR, LabelSettings} from '@progress/kendo-angular-progressbar';

//Composant barre de progression
@Component (
{
  selector: 'val-barre-progression',
  imports: 
  [
    KENDO_PROGRESSBAR
  ],
  templateUrl: './barre-progression.component.html',
  styleUrl: './barre-progression.component.scss'
})
export class BarreProgressionComponent 
{
  //Création
  constructor () 
  {
    this.labelSettings = 
    {
      visible: true,
      format: "percent",
      position: "end"
    };
  }

  //Etendu
  @Input ()
  public etendu!: number;

  //Position
  @Input ()
  public position!: number;

  //Paramètres du label
  public labelSettings: LabelSettings;
}
